import type {z} from 'zod';

import type {trimSchema} from '../schemas/trimSchema';
import {dateWindowRefinement} from './catalogueUi';

export const trimWindow = dateWindowRefinement<z.input<typeof trimSchema>>('validFrom', 'validTo');
